module.exports = __webpack_public_path__ + "static/media/en_outdoor_hot_permacool.f489c29d.jpg";